import React from 'react';
import { ShieldPRDForBrowser } from 'App/ShieldPRD/ShieldPRDForBrowser';
import { ShieldPRDForChromeApp } from 'App/ShieldPRD/ShieldPRDForChromeApp';
import { isCitrixChromeApp } from 'Environment/launchResource/device';
import { isBrowserExtensionSupportedOnPlatform } from 'Workspace/BrowserExtension/browserExtensionHelperMethods';

export const ShieldPRD: React.FC = () => {
	return (
		<>
			{isCitrixChromeApp() && <ShieldPRDForChromeApp />}
			{isBrowserExtensionSupportedOnPlatform() && <ShieldPRDForBrowser />}
		</>
	);
};
